import { render, staticRenderFns } from "./OrderColumnTransaction.vue?vue&type=template&id=be5a2238&"
import script from "./OrderColumnTransaction.vue?vue&type=script&lang=ts&"
export * from "./OrderColumnTransaction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports